import React from 'react';
import { Route } from 'react-router-dom';
import ScholarshipManagement from '@/pages/scholarship/ScholarshipManagement';

export const scholarshipRoutes = (
  <React.Fragment>
    <Route path="scholarships" element={<ScholarshipManagement />} />
    <Route path="scholarships/schemes" element={<ScholarshipManagement />} />
    <Route path="scholarships/applications" element={<ScholarshipManagement />} />
  </React.Fragment>
);
